module.exports = "/_next/static/images/7fb28bc6698ecbd17a1c893f56b57194-shield-icon.svg";